module.exports = __webpack_public_path__ + "img/7_12.3ed30306.png";